import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import moment from 'moment';
import { isEqual } from 'lodash';
import { Pagination, Table } from 'antd';
import { withWindowSize } from 'air-with-window-size';

import './SubscriptionsTable.css';

const pageSizeDefault = 7;
const pageSizeAlternative = 5;

@inject('commonStore', 'translationsStore')
@observer
class SubscriptionsTable extends Component {
  constructor(props) {
    super(props);
    this.defaultPageSize = 1;
    const dataSource = this.buildDataSourceWithKeys(this.props.subscriptions);
    // const pageSize = this.helperPageSize();
    const pageSize = this.defaultPageSize;

    let pagination = false;
    let paginationText = '';
    this.state = {
      dataSourceBuffer: dataSource,
      selectedRowKeys: [],
      pageSize,
      pagination,
      paginationText
    };
  }

  componentDidMount = () => {
    const dataSource = this.buildDataSourceWithKeys(this.props.subscriptions);
    if (!isEqual(dataSource, this.state.dataSourceBuffer) || (dataSource.length > 0 && !this.state.pagination)) {
      this.buildPagination();
    }
  };

  componentDidUpdate(prevProps) {
    const someSizeChanged = prevProps.componentHeight !== this.props.componentHeight || prevProps.windowHeight !== this.props.windowHeight;
    const dataSource = this.buildDataSourceWithKeys(this.props.subscriptions);
    if (someSizeChanged || !isEqual(dataSource, this.state.dataSourceBuffer) || (dataSource.length > 0 && !this.state.pagination)) {
      this.buildPagination();
    }
  }

  helperPageSize = () => {
    const defaultDocHeight = 800;
    if (this.props.documentHeight === defaultDocHeight) {
      return !this.props.group ? pageSizeDefault : pageSizeAlternative;
    } else {
      return !this.props.group
        ? Math.floor((this.props.documentHeight * pageSizeDefault) / defaultDocHeight)
        : Math.floor((this.props.documentHeight * pageSizeAlternative) / defaultDocHeight);
    }
  };

  changePageSize = pageSize => {
    this.setState({ pageSize });
  };

  helperPaginationText = (start, end, length) => {
    const { translationsStore } = this.props;
    if (length === 0) return `0 ${translationsStore.translate('subscriptions')}`;
    else if (length === 1) return `1 ${translationsStore.translate('subscription')}`;
    else return `${start}-${end} ${translationsStore.translate('of')} ${length} ${translationsStore.translate('subscriptions')}`;
  };

  buildDataSourceWithKeys = collection => collection.map((item, index) => ({ ...item, key: index }));

  buildPagination = () => {
    const dataSource = this.buildDataSourceWithKeys(this.props.subscriptions);
    const pageSize = this.helperPageSize();
    const pagination = {
      total: dataSource.length,
      defaultCurrent: 1,
      current: 1,
      // hideOnSinglePage: true,
      pageSize,
      simple: true,
      size: 'small',
      onChange: this.onPageChange
    };
    const start = 1;
    const end = Math.min(pagination.pageSize, pagination.total);

    const paginationText = this.helperPaginationText(start, end, dataSource.length);
    this.setState({
      dataSourceBuffer: dataSource,
      pageSize,
      pagination: { ...pagination },
      paginationText
    });
  };

  onPageChange = (page, pageSize) => {
    const dataSource = this.buildDataSourceWithKeys(this.props.subscriptions);
    const { pagination } = this.state;
    const start = (page - 1) * pageSize + 1;
    const end = Math.min(page * pageSize, pagination.total);
    let paginationText = this.helperPaginationText(start, end, dataSource.length);
    this.setState({
      dataSourceBuffer: dataSource,
      pagination: { ...pagination, current: page },
      paginationText
    });
  };

  render() {
    const { subscriptions, commonStore, translationsStore } = this.props;

    const dataSource = this.buildDataSourceWithKeys(subscriptions);

    const columns = [
      {
        key: 'number',
        dataIndex: 'number',
        title: translationsStore.translate('subscriptionManager.subscriptionTable.headerLabels.number'),
        render: (text, record, index) => index + 1
      },
      {
        key: 'product',
        dataIndex: 'product',
        title: translationsStore.translate('subscriptionManager.subscriptionTable.headerLabels.product'),
        render: (text, record) => (!!record.products && !!record.products[0].name ? record.products.map(product => product.name).join(', ') : '-')
      },
      {
        key: 'payment',
        dataIndex: 'payment',
        title: translationsStore.translate('subscriptionManager.subscriptionTable.headerLabels.payment'),
        render: (text, record) =>
          !!record.subscriptionType && record.subscriptionType.name ? translationsStore.translate(`subscriptionManager.types.${record.subscriptionType.name}`) : '-'
      },
      {
        key: 'end_date',
        dataIndex: 'end_date',
        className: 'ColumnCentered',
        title: translationsStore.translate('subscriptionManager.subscriptionTable.headerLabels.endDate'),
        render: (text, record) => new Date(record.end_date).toLocaleDateString(undefined, { year: 'numeric', month: '2-digit', day: '2-digit' })
      },
      {
        key: 'status',
        dataIndex: 'status',
        className: 'ColumnCentered',
        title: translationsStore.translate('subscriptionManager.subscriptionTable.headerLabels.status'),
        render: (text, record) => {
          const status = moment(record.end_date).isBefore(moment()) ? 'expired' : 'active';
          return translationsStore.translate(`subscriptionManager.statuses.${status}`);
        }
      },
      {
        key: 'plate',
        dataIndex: 'plate',
        className: 'ColumnCentered',
        title: translationsStore.translate('subscriptionManager.subscriptionTable.headerLabels.plate'),
        render: (text, record) => (record.vehicle && record.vehicle.license_plate && !record.available ? record.vehicle.license_plate : '-')
      },
      {
        key: 'imei',
        dataIndex: 'imei',
        className: 'ColumnCentered',
        title: translationsStore.translate('subscriptionManager.subscriptionTable.headerLabels.imei'),
        render: (text, record) => (record.installation && record.installation.node && record.installation.node.asset ? record.installation.node.asset.ain : '-')
      }
    ];

    return (
      <div className="SubscriptionsTable">
        <Table columns={columns} dataSource={dataSource} pagination={this.state.pagination} rowClassName="ClientRow" />
        {!commonStore.loading && (
          <div className="SubscriptionsTablePagination">
            <div>{this.state.paginationText}</div>
            {dataSource.length > this.helperPageSize() && <Pagination {...this.state.pagination} />}
          </div>
        )}
      </div>
    );
  }
}

export default withWindowSize(SubscriptionsTable);



// WEBPACK FOOTER //
// ./src/components/App/SubscriptionManagerDashboard/SubscriptionsWithGroups/SubscriptionsTable/SubscriptionsTable.js